import { Injectable, Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'displaySubjectNamePipe',
    standalone: false
})
@Injectable({ providedIn: 'root' })
export class DisplaySubjectNamePipe implements PipeTransform {
    transform(item: any): string {
        if (!item) {
            return ''
        }
        if (item.subj_nazev || item.subjNazev) {
            return item.subj_nazev ?? item.subjNazev
        } else {
            let subjName = ''

            if (item.subj_titul_pred_jmenem || item.subjTitulPredJmenem) {
                subjName = (item.subj_titul_pred_jmenem ?? item.subjTitulPredJmenem) + ' '
            }

            subjName += (item.subj_jmeno ?? item.subjJmeno) + ' ' + (item.subj_prijmeni ?? item.subjPrijmeni)

            if (item.subj_titul_za_jmenem || item.subjTitulZaJmenem) {
                subjName += ' ' + (item.subj_titul_za_jmenem ?? item.subjTitulZaJmenem)
            }

            return subjName
        }
    }
}